module.exports = __webpack_public_path__ + "img/2@2x (1).32b9e67e.png";